import template from './subcase-comment-section.pug';
import controller from './subcase-comment-section.controller';

const CommentSectionComponent = {
  template,
  controller,
  bindings: {
    subCase: '=',
  },
};

export default CommentSectionComponent;



// WEBPACK FOOTER //
// ./client/components/subcase-comment-section/subcase-comment-section.component.js